module.exports = __webpack_public_path__ + "static/img/woman.f8221db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/woman.png
// module id = apG9
// module chunks = 2